// Reusable SVG icons as constants

const SHOPPING_CART_ICON = `<svg class="n24-icon nvcarticon n24-cart" style="" aria-labelledby="shopping_cart">
                    <use xlink:href="#n24-cart"></use>
                   </svg>`
const PADLOCK_ICON = `
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 401.998 401.998" xml:space="preserve" class="padlock">
    <path d="M357.45,190.721c-5.331-5.33-11.8-7.993-19.417-7.993h-9.131v-54.821c0-35.022-12.559-65.093-37.685-90.218C266.093,12.563,236.025,0,200.998,0c-35.026,0-65.1,12.563-90.222,37.688C85.65,62.814,73.091,92.884,73.091,127.907v54.821h-9.135c-7.611,0-14.084,2.663-19.414,7.993c-5.33,5.326-7.994,11.799-7.994,19.417V374.59c0,7.611,2.665,14.086,7.994,19.417c5.33,5.325,11.803,7.991,19.414,7.991H338.04c7.617,0,14.085-2.663,19.417-7.991c5.325-5.331,7.994-11.806,7.994-19.417V210.135C365.455,202.523,362.782,196.051,357.45,190.721z M274.087,182.728H127.909v-54.821c0-20.175,7.139-37.402,21.414-51.675c14.277-14.275,31.501-21.411,51.678-21.411c20.179,0,37.399,7.135,51.677,21.411c14.271,14.272,21.409,31.5,21.409,51.675V182.728z" />
  </svg>
`;

// Internal styles from cart.template.style.scss
const INTERNAL_STYLES = `
<style>
.nav-header-list {
  position: relative;
  height: 44px;
  width: 100%;
  padding: 0;
  user-select: none;
  line-height: 20px;
  list-style: none;
  margin: 0;
}

.nav-header-list .nav-header-item {
  float: left;
  position: relative;
  padding-left: 5px !important;
  list-style: none;
}

.nav-header-list .nav-header-item .nvcarticon {
  fill: #666;
  pointer-events: none;
}

.nav-header-list .nav-header-item .n24-icon {
  width: 24px;
  height: 24px;
  pointer-events: none;
}

.nav-header-list .nav-header-item .nav-badge {
  color: #000 !important;
  background-color: #76b900;
  font-size: 11px;
  border-radius: 55%;
  position: absolute;
  top: 5px;
  padding: 3px 0 3px 1px;
  min-width: 15px;
  height: 11px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
  line-height: 1;
  left: 10px;
  z-index: 1;
}

.nav-header-list .nav-header-item .nav-cart-link {
  display: inline-block;
  width: 25px;
  position: relative;
  top: 14px;
  cursor: pointer;
  text-decoration: none;
}

.nav-header-list .nav-header-item .nav-cart-link svg {
  pointer-events: none;
}

@media (max-width: 638px) {
  .nav-header-list .nav-header-item .nav-header-list {
    width: 20%;
  }
}

.cart-counter {
  left: 12px !important;
  cursor: pointer;
  justify-content: center;
  min-width: 16px;
  min-height: 12px;
  border-right: none;
}

@media (max-width: 992px) {
  .cart-counter {
    left: 8px !important;
  }
}

.cart-section {
  position: absolute;
  right: -200%;
  top: 50px !important;
  z-index: 9999;
}

@media (max-width: 992px) {
  .cart-section {
    left: auto;
    /* top: 0 !important; */
    right: calc(90% - 100px);
  }
}

@media (max-width: 638px) {
  .navigation
    .global-nav
    .nav-header-container
    .nav-tools-container
    .nav-header-list
    .nav-header-item.profile-item {
    position: absolute;
    left: 100%;
    top: 5%;
  }
}

.padlock {
  margin-right: 5px;
  max-width: 16px;
  width: 100%;
  fill: #000;
  margin-bottom: 4px;
  display: inline-block !important;
  vertical-align: middle;
}

.js-out-of-stock {
  display: none !important;
}

.js-checkout {
  background-color: #76b900;
  border: none;
  color: #000;
  cursor: pointer;
  display: inline-block;
  font-size: 1em;
  font-weight: bold;
  line-height: 1em;
  padding: 15px 2px 10px;
  text-align: center;
  text-decoration: none;
  text-transform: none;
  transition: background-color 0.2s ease;
}

.js-checkout:hover {
  background-color: #91c733 !important;
  transition: all 0.2s ease-out;
}

/* STOCK TEXT */
.js-out-of-stock,
.js-in-stock {
  font-size: 16px;
  text-transform: none;
  font-weight: bold;
  font-family: NVIDIA, Helvetica, Arial, Sans-Serif;
  line-height: 24px;
}

.js-out-of-stock p,
.js-in-stock p {
  margin: 0;
}

.cart__items .clearfix {
  overflow: auto;
}

.cart__items .clearfix::after {
  content: "";
  clear: both;
  display: table;
}

#cart > ul {
  padding-left: 0;
}

.cart-main-section {
  display: inline-block;
  cursor: default;
}

/* CART WHITE POPUP */
.cart_white {
  background: #fff;
  padding: 30px;
  width: 515px;
  display: none;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

.cart_white:before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-left: 22px solid transparent;
  border-right: 22px solid transparent;
  border-bottom: 22px solid #fff;
  top: -10px !important;
  right: 50px;
}

.cart_white.cart--shown {
  display: block;
  margin-top: 10px !important;
  margin-bottom: 0;
  bottom: 0;
  overflow-y: auto;
}

.cart_white .cart__empty {
  margin: 30px 0;
  text-align: center;
  color: #000;
}

.cart_white .cart__close {
  width: 30px;
  height: 30px;
  cursor: pointer;
  float: right;
  position: relative;
}

.cart_white .cart__close:before,
.cart_white .cart__close:after {
  position: absolute;
  content: "";
  width: 29px;
  height: 2px;
  left: 0;
  top: 9px;
  background-color: #666;
  display: block;
  border-radius: 10px;
  transition: all 0.2s;
  pointer-events: none;
}

.cart_white .cart__close:before {
  transform: rotate(135deg);
}

.cart_white .cart__close:after {
  transform: rotate(45deg);
}

.cart_white .cart__close:hover:before,
.cart_white .cart__close:hover:after {
  background-color: #666;
}

.cart_white .cart__title {
  font-family: NVIDIA, Helvetica, Arial, Sans-Serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 32px;
  color: #76b900;
  text-align: justify;
}

.cart_white .cart__items {
  overflow-y: auto;
  width: 100%;
  padding: 0;
}

.cart_white .cart__items li {
  padding: 20px 0;
  list-style: none;
}

.cart_white .cart_desc {
  padding-left: 10px;
  vertical-align: top;
  font-family: NVIDIA, Helvetica, Arial, Sans-Serif;
  font-weight: normal;
  font-size: 16px;
}

.cart_white .cart__total {
  font-family: NVIDIA, Helvetica, Arial, Sans-Serif !important;
  font-weight: bold;
  font-size: 26px;
  line-height: 32px;
  padding: 13px 0 22px;
  text-align: right;
  color: #1a1a1a;
  border-top: 2px solid #eee;
}

.cart_white .cart__checkout-button {
  width: 100%;
  margin-bottom: 30px;
}

.cart_white .cart__continue-shopping {
  color: #76b900;
  display: block;
  text-align: center;
}


/* QUANTITY SELECTOR */
.cart_white .quantity-selector__dec,
.cart_white .quantity-selector__inc {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 2px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px 12px;
  background-color: #f5f5f5;
  border: 1px solid #d0d0d0;
  border-radius: 3px;
  transition: all 0.2s ease;
  vertical-align: middle;
}

.cart_white .quantity-selector__dec {
  background-image: url("data:image/svg+xml,%3Csvg fill='%23656565' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Crect y='244.364' width='512' height='23.273'/%3E%3C/svg%3E");
}

.cart_white .quantity-selector__inc {
  background-image: url("data:image/svg+xml,%3Csvg fill='%23656565' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 472.615 472.615'%3E%3Cpolygon points='246.154,226.462 246.154,0 226.462,0 226.462,226.462 0,226.462 0,246.154 226.462,246.154 226.462,472.615 246.154,472.615 246.154,246.154 472.615,246.154 472.615,226.462'/%3E%3C/svg%3E");
}

.cart_white .quantity-selector__dec:hover,
.cart_white .quantity-selector__inc:hover {
  background-color: #e8e8e8;
  border-color: #b0b0b0;
}

.cart_white .quantity-selector__dec:active,
.cart_white .quantity-selector__inc:active {
  background-color: #d8d8d8;
  transform: scale(0.95);
}

.cart_white .quantity-selector__dec.disabled,
.cart_white .quantity-selector__inc.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f5f5f5;
}
.cart__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  width: 100%;
}
.cart_white .quantity-selector__value {
  display: inline-block;
  max-width: 40px;
  text-align: center;
  vertical-align: middle;
  margin: 0 4px;
}

.cart_white .quantity-selector__inc {
  margin-left: 4px;
}

.cart_white .cart-item {
  width: 100%;
}

.cart_white .cart-item .cart-item__quantity-selector {
  float: left;
  max-width: 110px;
  text-align: left;
  color: #656565;
  white-space: nowrap;
}

.cart_white .cart-item .cart-item__name {
  font-family: NVIDIA, Helvetica, Arial, Sans-Serif !important;
  font-weight: bold;
  font-size: 16px;
  color: #000;
  float: left;
  line-height: 20px;
  max-width: 308px;
  margin: 0 15px;
}
@media (max-width: 1023px) {
  .cart--shown {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 10px !important;
    margin-bottom: 0;
    overflow-y: auto;
    padding: 15px;
    margin-bottom: 0;
  }
  .cart_white:before {
    right: 70px;
  }
  .nv__cart__items {
    max-width: 100%;
    width: 100%;
  }
  .cart_white .quantity-selector__dec,
  .cart_white .quantity-selector__inc {
    width: 28px;
    height: 28px;
    background-size: 14px 14px;
  }
  .cart_white .cart-item .cart-item__quantity-selector {
    display: flex;
    flex: 0 0 auto;
    justify-content: flex-start;
  }
  .cart_white .quantity-selector__dec,
  .cart_white .quantity-selector__inc {
    width: 15px;
    height: 15px;
    background-size: 8px 8px;
  }
  .cart_white .quantity-selector__value {
    margin: 0;
  }
  .cart_white .cart__title {
    margin: 15px;
    font-weight: 400;
  }
  .cart_white .cart-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }
  .cart_white .cart-item .cart-item__name {
    flex: 1 1 auto;
    margin: 0 10px;
    max-width: none;
  }
  .cart_white .cart-item .cart_remove {
    color: #76b900;
    font-size: 14px;
    font-weight: 400;
  }
  .cart_white .cart__items .cart__total {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 15px;
  }
  .cart_white .cart__checkout-button {
    margin: 15px auto;
    display: block;
    max-width: 100%;
  }
}

/* MOBILE */
@media (max-width: 768px) {
  .cart_white {
    top: 5%;
    bottom: 0 !important;
    right: 5px !important;
    max-width: 100%;
    width: 100%;
    position: fixed;
    justify-content: flex-start !important;
    width: 89%;
  }
  .cart_white:before {
    display: none;
  }
  .cart_white .cart__title {
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 0;
  }

  .cart_white .cart__total {
    line-height: 30px;
    font-size: 22px;
    padding: 10px;
  }

  .cart_white .cart__close {
    width: 40px;
    height: 40px;
    min-width: 44px;
    min-height: 44px;
    z-index: 10001;
  }

  .cart_white .cart__close:before,
  .cart_white .cart__close:after {
    pointer-events: none;
  }
  .cart_white .cart-item .cart-item__name {
    flex: 1 1 auto;
    margin: 0 10px;
    max-width: 150px;
  }
}
.cart_white .cart-item .cart-item__name .decimal-price {
  top: -0.5em;
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

.cart_white .cart-item .cart-item__sub-name {
  font-size: 24px;
  color: #656565;
}
.cart_white .cart-item .cart-item__price {
  font-weight: bold;
  font-size: 16px;
  color: #1a1a1a;
  text-align: right;
  float: right;
  line-height: 24px;
  margin-right: 5px;
}
.js-cart-item-remove {
  font-weight: 400;
  font-size: 14px;
  color: #76b900;
  cursor: pointer;
}
.cart_white .cart-item .cart-item__product-info-message {
  clear: both;
  display: block;
  width: 100%;
  margin-top: 8px;
  font-size: 16px;
  color: #76b900;
  line-height: 1.5;
}
.nvCart__tabs {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  height: 40px;
  align-content: space-between;
  justify-content: center;
}
.nvCart__tabs button.tablinks {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  align-self: center;
  padding: 12px;
  font-weight: 400;
  text-transform: capitalize;
  width: 50%;
  color: #666;
  cursor: pointer;
  margin: 10px auto;
  border: 2px solid #eee;
  box-shadow: #ccc 0 0 0.25em;
}
.nvCart__tabs button.tablinks.active {
  background: #fff;
  color: #76b900;
  border-bottom: none;
  outline: 0;
  cursor: default;
  font-weight: 500;
  box-shadow: #e4e4e4 0 0 0.25em;
}
.nvCart__tabs button.tablinks:focus {
  outline: none;
}
// .tabcontent{padding:25px;}
.nvCart__tabs .nvCart__tabcontent.active {
  display: block;
  margin: 10px auto;
}
.nvCart__tabs .nvCart__tabcontent.active .cart__items {
  padding: 5px;
}

</style>
`;

// Handlebars template as a separate constant
const HANDLEBARS_TEMPLATE = `
  {{#if products.length}}
    {{#if (moreThanOneCategory products)}}
      <div class="nvCart__tabs">
        {{#each (categoryProductQuantity products)}}
          <button class="tablinks {{this.category}} {{#ifEquals ../activeTab this.category}} active{{/ifEquals}}" onclick="openTab(event, '{{this.category}}')">
            {{uppercaseIfNvidia this.category}} Products ({{this.quantity}})
          </button>
        {{/each}}
      </div>
    {{/if}}
    
    {{#each categories}}
      <div id="{{this}}" class="tabcontent nvCart__tabcontent {{this}}-tabcontent">
        <ul class="cart__items scroll" style="max-height:{{../height}}px">
          {{#each (getProductsWithCategory this)}}
            <li class="cart-item clearfix cart-item--{{id}}">
              <div class="cart-item__quantity-selector quantity-selector">
                {{#if (isExist isQuantity)}}
                  {{#ifProductQuantityIsOne id}}
                    <a class="quantity-selector__dec disabled"></a>
                  {{else}}
                    {{#ifProductOutOfStock id}}
                      <a class="quantity-selector__dec disabled"></a>
                    {{else}}
                      <a class="quantity-selector__dec js-cart-item-dec" data-marketplace-id="{{id}}"></a>
                    {{/ifProductOutOfStock}}
                  {{/ifProductQuantityIsOne}}
                {{/if}}
                
                <span class="quantity-selector__value">{{quantity}}</span>
                
                {{#if (isExist isQuantity)}}
                  {{#ifProductLimitReached id}}
                    <a class="quantity-selector__inc disabled"></a>
                  {{else}}
                    {{#ifProductOutOfStock id}}
                      <a class="quantity-selector__inc disabled"></a>
                    {{else}}
                      {{#ifAvailableStock id}}
                        <a class="quantity-selector__inc disabled"></a>
                      {{else}}
                        <a class="quantity-selector__inc js-cart-item-inc" data-marketplace-id="{{id}}"></a>
                      {{/ifAvailableStock}}
                    {{/ifProductOutOfStock}}
                  {{/ifProductLimitReached}}
                {{/if}}
              </div>
              
              <div class="cart-item__name">
                {{name}}
                <div class="cart_remove">
                  <a class="cart-item__remove js-cart-item-remove" data-product-id={{this.id}}>{{remove}}</a>
                </div>
              </div>
              
              <div class="cart-item__price">{{#getTotalPriceFormat totalPrice}}{{/getTotalPriceFormat}}</div>
              
              {{#ifProductLimitReached id}}
                <div class="cart-item__product-info-message getProductStock">
                  {{#getProductStockMessage id productType}}{{/getProductStockMessage}}
                </div>
              {{/ifProductLimitReached}}
              
              {{#ifProductOutOfStock id}}
                <div class="cart-item__product-info-message getProductOutOfStock">
                  {{#getProductOutOfStockMessage id}}{{/getProductOutOfStockMessage}}
                </div>
              {{/ifProductOutOfStock}}
              
              {{#ifAvailableStock id}}
                <div class="cart-item__product-info-message getAvailableStock">
                  {{#getAvailableStockMessage id}}{{/getAvailableStockMessage}}
                </div>
              {{/ifAvailableStock}}
            </li>
          {{/each}}
        </ul>
        <div class="cart__total"></div>
      </div>
    {{/each}}
    
    <div class="nv-button js-checkout cart__checkout-button">
      ${PADLOCK_ICON}
      <span>{{checkout}}</span>
    </div>
    
    {{#if (moreThanOneCategory products)}}
      <div class="tabbedCart__updates" id="tabbedCart__updates" style="color:#77ba02;font-weight: bold;">
        <span class="cart_update_message">{{#tabbedCartMessage}}{{/tabbedCartMessage}}</span>
      </div>
    {{else}}
      <div class="tabbedCart__updates" id="tabbedCart__updates" style="display:none;color:#77ba02;font-weight: bold;">
        <span class="cart_update_message">{{#tabbedCartMessage}}{{/tabbedCartMessage}}</span>
      </div>
    {{/if}}
    
    {{#isNvidiaTab activeTab}}
      <div class="cart__updates" id="cart__updates" style="display:none;color:#77ba02;font-weight: bold;">
        <span class="cart_update_message">{{#updatedQuantity}}{{/updatedQuantity}}</span>
      </div>
      <div class="mixedCart__updates" id="mixedCart__updates" style="display:none;color:#77ba02;font-weight: bold;">
        <span class="cart_update_message">{{#mixedCartMessage}}{{/mixedCartMessage}}</span>
      </div>
      <div class="errorCart__updates" id="errorCart__updates" style="display:none;color:#ff3333;font-weight: bold;">
        <span class="cart_update_message">{{#checkoutError}}{{/checkoutError}}</span>
      </div>
    {{/isNvidiaTab}}
  {{else}}
    <div class="cart__empty">{{cartIsEmpty}}</div>
  {{/if}}
`;

export const nvCartTemplate = {
  generate(): string {
    return `
      ${INTERNAL_STYLES}
      <span class="nav-badge cart-counter">0</span>
      <a aria-label="Shopping Cart" aria-haspopup="true" aria-expanded="false" id="shoppingcart" class="nav-cart-link menu-level-1" href="javascript:void(0);">
        ${SHOPPING_CART_ICON}
      </a>
      <div class="cart-blocker"></div>
      <div class="cart-main-section">
        <div class="cart-section">
          <div class="cart_white cart">
            <div class="cart__header">
              <a class="cart__close" href="javascript:void(0);"></a>
              <div class="cart__title">Cart</div>
            </div>
            <div id="cart" class="nv__cart__items">
              <div class="cart__empty">Your cart is empty.</div>
            </div>
          </div>
        </div>
      </div>
      <script type="x-tmpl-mustache" id="nv-cartTemplate">${HANDLEBARS_TEMPLATE}</script>
    `;
  }
};